import { c as _c } from "react/compiler-runtime";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import styles from "./FundraiserOrganizationInfo.module.scss";
import Link from "next/link";
import { Fragment } from "react";
export const FundraiserOrganizationInfo: React.FC<{
  name: string;
  logo: SanityImageObject;
  textTemplate: string;
  organizationSlug: string;
}> = t0 => {
  const $ = _c(14);
  const {
    name,
    logo,
    textTemplate,
    organizationSlug
  } = t0;
  const t1 = `/${organizationSlug}`;
  let t2;
  if ($[0] !== name || $[1] !== t1) {
    t2 = <Link href={t1} data-cy="fundraiser-organization-link">{name}</Link>;
    $[0] = name;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const orgLink = t2;
  let t3;
  if ($[3] !== orgLink || $[4] !== textTemplate) {
    const parts = textTemplate.split("{org}");
    t3 = parts.map((part, index) => <Fragment key={index}>{part}{index < parts.length - 1 && orgLink}</Fragment>);
    $[3] = orgLink;
    $[4] = textTemplate;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const text = t3;
  let t4;
  if ($[6] !== logo || $[7] !== name) {
    t4 = <div className={styles.logo}><ResponsiveImage image={logo} alt={name} sizes="(min-width: 1521px) 120px, 96px" layout="responsive" /></div>;
    $[6] = logo;
    $[7] = name;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== text) {
    t5 = <div className={styles.text}>{text}</div>;
    $[9] = text;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className={styles.container} data-cy="fundraiser-organization-info">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};